module.exports = __webpack_public_path__ + "static/media/burger-menu.773aa723.svg";